import { NetworkStatus } from '@absis/core-plugins';

/**
 * @deprecated use sessionStorage instead
 */
export const sessionOrLocalStorage = window.sessionStorage;

export const sessionStorage = window.sessionStorage;

export const currentNetworkStatus = (): Promise<NetworkStatus> => {
  const status: NetworkStatus = {
    connected: window.navigator && window.navigator.onLine,
    connectionType: 'unknown',
  };
  return Promise.resolve(status);
};

export const removeNetworkListeners = (nStatus: () => void): void => {
  window.removeEventListener('online', nStatus);
  window.removeEventListener('offline', nStatus);
};
